import { FC, useState } from "react";
import { address } from "../../pages/Perfil/addresses/addressesIndex"; // Ajuste os imports conforme sua árvore
import "./index.css"; // Aponte para onde você salvou o CSS acima
import { DotsIcon } from "../MenuIcons/Dots";
import { cepToMask } from "../../functions/mask";
import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

type props = {
  data: address;
  deleteAddress: (id: number) => void;
};

const AddressCard: FC<props> = ({ data, deleteAddress }) => {
  const [open, setOpen] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const navigate = useNavigate();
  const { loginInfo } = useAuth();

  const [boxPosition, setBoxPosition] = useState({ top: 0, left: 0 });

  function FloatBox(e: any) {
    try {
      const rect = e.currentTarget.getBoundingClientRect();
      // O -100px no left garante que o menu de contexto abra "para dentro" da tela
      setBoxPosition({ top: rect.bottom + 4, left: rect.left - 100 });
      setOpen(!open);
    } catch (error) {
      console.log(error);
    }
  }

  function edit() {
    navigate(`${data.id}`);
  }

  function handleDeleteClick() {
    setOpen(false); // Fecha o menu flutuante primeiro
    setDeleteModal(true); // Abre o modal
  }

  return (
    <>
      <div className="perfil-address-card-main">
        <div
          className="perfil-address-card-info"
          onClick={() => setOpen(false)}
        >
          <span>
            {data.district}, {data.street}, {data.number}
          </span>

          {data.complement && <span>{data.complement}</span>}
          <span>
            {data.city}, {data.state}, {cepToMask(data.zipCode)}
          </span>
        </div>

        <div className="perfil-address-card-options">
          <button onClick={(event) => FloatBox(event)}>
            <DotsIcon />
          </button>
        </div>
      </div>

      {/* Menu Flutuante */}
      {open && (
        <div
          className="perfil-address-card-menu"
          style={{
            position: "fixed",
            top: `${boxPosition.top}px`,
            left: `${boxPosition.left}px`,
          }}
        >
          <button onClick={() => edit()}>
            <span>Editar</span>
          </button>
          <button onClick={() => handleDeleteClick()}>
            <span>Excluir</span>
          </button>
        </div>
      )}

      {/* Modal de Confirmação de Exclusão */}
      {deleteModal && (
        <div className="perfil-address-modal-overlay">
          <div className="perfil-address-modal-content">
            <div className="perfil-address-modal-header">
              <h5>Excluir endereço</h5>
              <button onClick={() => setDeleteModal(false)}>✕</button>
            </div>

            <div className="perfil-address-modal-body">
              <span>Deseja excluir este endereço?</span>

              <div className="perfil-address-modal-box">
                <span>
                  {data.district}, {data.street}, {data.number}
                </span>
                {data.complement && <span>{data.complement}</span>}
                <span>
                  {data.city}, {data.state}, {cepToMask(data.zipCode)}
                </span>
              </div>
            </div>

            <div className="perfil-address-modal-footer">
              <button
                className="perfil-address-modal-btn"
                onClick={() => {
                  setDeleteModal(false);
                  deleteAddress(data.id);
                }}
              >
                Excluir endereço
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export { AddressCard };
